import { env } from "@/common/env/client.mjs";

export const getBaseUrl = () => {
  const isSSR = typeof window === "undefined";

  if (isSSR) {
    return env.NEXT_PUBLIC_API_BASE_URL;
  }

  return env.NEXT_PUBLIC_API_BASE_URL; // or window.location.origin - @TODO - check if this is correct
};
